import * as yup from "yup";

import { PromotionTypeEnum } from "@krea/shared/types/common";

import type { IPromotionInput } from "@/features/lender-responses/types/lender-response";

export const bidPromotionSchema: yup.ObjectSchema<IPromotionInput> = yup
  .object()
  .shape({
    value: yup
      .number()
      .positive()
      .integer()
      .moreThan(0, "Must be at least 1")
      .required("Required"),
    type: yup.string().oneOf(Object.values(PromotionTypeEnum)).required(),
  });
